import React from 'react'
import { config } from 'config'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import styles from './BlogHead.module.scss'
import Time from 'react-time'
class BlogHead extends React.Component {

  static propTypes () {
    return {
      data: React.PropTypes.object,
    }
  }

  render () {
    const data = this.props.data;
    const linearTint = 'linear-gradient(rgba(57, 61, 81, 0.75), rgba(57, 61, 81, 0.75))';
    const cover = '/images/default-splash.jpg'
    const splashContainerStyle = {
      background: `${linearTint}, url("${cover}") center center / cover no-repeat`
    };

    return (
      <div className={styles.blogHead}>
        <div className={styles.splash} style={splashContainerStyle}>
          <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(2)} ${rhythm(3/4)}`,
            }}
          >
            <span className="text-malibu">Blog </span><span className="text-bright-turquoise"> /</span>
            <h1>{data.title}</h1>
            <Time value={data.date} format="YYYY MM DD" />
          </Container>
        </div>
      </div>
    )
  }
}

export default BlogHead



/** WEBPACK FOOTER **
 ** ../components/BlogHead.js
 **/